import { Component } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import { authConfig } from "./auth.config";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { SarService } from "./components/layout/service/sar.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { Location } from "@angular/common";
import { HomeAllRequestService } from "./components/layout/service/home-all-request.service";
import { ModalTermsComponent } from "./components/layout/body-home/modal-terms/modal-terms.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  })
export class AppComponent {
  logged: boolean;
  isPagePublic: boolean;
  modules: any;
  claims: any;
  Token: string;
  //modalsTerms
  // id: any;
  // hasAgreeed: any;

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private dataApi: SarService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    public translate: TranslateService,
    private location: Location
  ) {
    this.logged = false;
    this.isPagePublic = false;
    if (this.validateVisitUrl(String(this.location.path()))) {
      this.isPagePublic = true;
    } else {
      this.oauthService.configure(authConfig);
      this.oauthService.tokenValidationHandler = new JwksValidationHandler();
      if (window.location.pathname != "/") {
        sessionStorage.setItem("redirectURL", String(window.location.pathname));
      }
      this.oauthService.loadDiscoveryDocumentAndLogin().then(() => {
        if (this.oauthService.hasValidAccessToken()) {
          this.claims = this.oauthService.getIdentityClaims();
          this.spinner.show("InitPage");
          if (sessionStorage.Token === undefined) {
            this.dataApi.getToken().subscribe(
              (data: any) => {
                /*   dev se comenta para levantar local                 */
                if(data.notModule) {
                  this.spinner.hide('InitPage');
                  this.router.navigate(['/not-modules']);
                  //this.isPagePublic = true;
                  this.logged = true;
                  return;
                }
                // /*   dev se comenta hasta acá para levantar local */
                sessionStorage.setItem("Token", data.SARToken);
                sessionStorage.setItem("RefreshToken", data.RefreshToken);
                this.getmodules();
              },
              () => {
                /*  se comenta solo linea abajo, para levantar local */
                this.modules = [];//access to basic pages //dev

                /* se ocupa para levantar local */
                // this.modules = [
                //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                //   19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
                //   34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
                //   46, 47 // se incorporarón estos modulos para pruebas localmente
                // ]; 
                this.Token = sessionStorage.getItem("Token") || "";
                const currentUser = {
                  email: this.claims.preferred_username,
                  name: this.claims.name,
                  modules: this.modules,
                };
                sessionStorage.setItem(
                  "currentUser",
                  JSON.stringify(currentUser)
                );
                sessionStorage.setItem("isTranslated", "false");
                this.logged = true;
                this.spinner.hide("InitPage");
                this._snackBar.open("error", "", {
                  duration: 3000,
                });
              }
            );
          } else {
            this.getmodules();
          }
        } else {
          this.logged = false;
        }
      });
    }
  }

  title = "BHP";

  validateVisitUrl(urlMaster) {
    let adminPages = [
      //pages to visitors URLS EJ: /
      "/form-confirmation/success",
      "/form-confirmation/fail",
      "/personal-access-form",
      "/leader-access-form",
      "/medical-test",
      "/medical-confirmation",
      "/404",
    ];
    for (let url of adminPages) {
      if (urlMaster.includes(url)) {
        return true;
      }
    }
    return false;
  }

  getmodules() {
    this.dataApi.getModules().subscribe(
      (data: any) => {
        /* se ocupa para levantar dev */
        this.modules = data; //dev
        /* se descomenta para levantar local */
        // this.modules = [
        //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        //   19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
        //   34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
        //   46, 47 // se incorporarón estos modulos para pruebas localmente
        // ]; //qa and prod
        const currentUser = {
          email: this.claims.preferred_username,
          name: this.claims.name,
          modules: this.modules,
        };
        sessionStorage.setItem("currentUser", JSON.stringify(currentUser));
        this.logged = true;
        this.spinner.hide("InitPage");
        if (sessionStorage.getItem("redirectURL") != null) {
          this.router.navigate([sessionStorage.getItem("redirectURL")]);
          sessionStorage.removeItem("redirectURL");
        }
      },
      () => {
        /* se ocupa para levantar dev */
        this.modules = []; //access to basic pages //dev
        /* se descomenta para levantar local */
        // this.modules = [
        //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        //   19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
        //   34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
        //   46, 47 // se incorporarón estos modulos para pruebas localmente
        // ]; 
        const currentUser = {
          email: this.claims.preferred_username,
          name: this.claims.name,
          modules: this.modules,
          jwtToken: this.Token,
        };
        sessionStorage.setItem("currentUser", JSON.stringify(currentUser));
        this.logged = true;
        this.spinner.hide("InitPage");

        this._snackBar.open("error", "", {
          duration: 3000,
        });
      }
    );
  }

  getlanguajeSpinner() {
    let lang = sessionStorage.getItem("lang");
    if (lang == null || lang == undefined) {
      return "en";
    } else {
      return lang;
    }
  }
}
